





import { defineComponent, onMounted } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { useRouter } from '@ideavivat/vivat-2';

const App = defineComponent({
  setup() {
    const { onResult, refetch } = useQuery(gql`
      query meCheck {
        me {
          id
        }
      }
    `, {}, {
      fetchPolicy: 'network-only',
    });

    onMounted(() => {
      refetch();
    });

    const { router } = useRouter();

    onResult((result: any) => {
      if (!result?.data?.me) router.replace({ name: 'Logout' });
    });
  },
});

export default App;
